import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=b597ed4c&scoped=true"
import script from "./ProductVariants.vue?vue&type=script&lang=js"
export * from "./ProductVariants.vue?vue&type=script&lang=js"
import style0 from "./ProductVariants.vue?vue&type=style&index=0&id=b597ed4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b597ed4c",
  null
  
)

export default component.exports